import type { AuthProvider } from "@refinedev/core";
import { TOKEN_KEY, USER_KEY } from "@/lib/constants";

/**
 * mockAuthProvider — admin fake JÁ logado (MOCK MODE).
 *
 * `check` sempre devolve authenticated=true, então o painel abre direto na
 * lista de usuários sem tela de login e SEM API. `getIdentity`/`getPermissions`
 * retornam o admin fixo. `login` (caso a tela de login seja acessada via URL)
 * aceita qualquer credencial e entra. Nenhuma ação do usuário é necessária.
 */
const MOCK_ADMIN = {
  id: "usr_admin_0001",
  email: "admin@melapp.com.br",
  role: "admin" as const,
  nome: "Equipe MEL",
};

function ensureSession() {
  if (!localStorage.getItem(TOKEN_KEY)) {
    localStorage.setItem(TOKEN_KEY, "mock-admin-token");
    localStorage.setItem(USER_KEY, JSON.stringify(MOCK_ADMIN));
  }
}

export const mockAuthProvider: AuthProvider = {
  login: async () => {
    localStorage.setItem(TOKEN_KEY, "mock-admin-token");
    localStorage.setItem(USER_KEY, JSON.stringify(MOCK_ADMIN));
    return { success: true, redirectTo: "/" };
  },

  logout: async () => {
    // No mock mantemos a sessão para não cair em loop de login; re-loga já.
    localStorage.setItem(TOKEN_KEY, "mock-admin-token");
    localStorage.setItem(USER_KEY, JSON.stringify(MOCK_ADMIN));
    return { success: true, redirectTo: "/" };
  },

  check: async () => {
    ensureSession();
    return { authenticated: true };
  },

  onError: async () => ({}),

  getPermissions: async () => MOCK_ADMIN.role,

  getIdentity: async () => {
    ensureSession();
    return {
      id: MOCK_ADMIN.id,
      name: MOCK_ADMIN.nome,
      email: MOCK_ADMIN.email,
      avatar: "/mel-icon.svg",
    };
  },
};
